// 리포트/카드 표시용 스탯 파생 (원시 신호 → 사람이 읽는 수치). 내용은 안 봄(§6).

import type { RawSignals } from "./types";

export interface DisplayStats {
  speed: number; // 분당 타수(보조 신호이지만 자랑용)
  backspaces: number;
  timeSpentSec: number;
  toFirstSec: number;
  words: number;
  exclaims: number;
}

export function deriveDisplayStats(s: RawSignals): DisplayStats {
  const sec = Math.max(1, Math.round(s.durationMs / 1000));
  return {
    speed: Math.round(s.insertCount / (s.durationMs > 0 ? s.durationMs / 60000 : 1)),
    backspaces: s.deleteCount,
    timeSpentSec: sec,
    toFirstSec: Math.max(0, Math.round(s.startDelayMs / 1000)),
    words: s.text.trim().split(/\s+/).filter(Boolean).length,
    exclaims: s.exclaimCount,
  };
}
